import React, {useState} from 'react';
import emailjs from 'emailjs-com';
import './Contact Form.css';
import contact_img from "../../../../assets/img/contact/contact-01.png";

const ContactForm = () => {
    
    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [messageClass, setMessageClass] = useState('');

    const clearFeedbackMessage = () => {
        setTimeout(() => {
            setFeedbackMessage('');
            setMessageClass('');
        }, 3000);  // 3000 milliseconds = 3 seconds
    };

    const sendEmail = (e) => {
        e.preventDefault();

        // Replace 'YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', and 'YOUR_USER_ID' with your actual values from EmailJS
        emailjs.sendForm('service_bn18fxk', 'template_yidpgbt', e.target, 'kUohdOuyQ2hxZlxQe')
            .then((result) => {
                console.log(result.text);
                setFeedbackMessage('Message sent successfully!');
                setMessageClass('success');
                clearFeedbackMessage();  // Call to clear the message after a few seconds
            }, (error) => {
                console.log(error.text);
                setFeedbackMessage('Failed to send the message, please try again later.');
                setMessageClass('error');
                clearFeedbackMessage();
            });

        e.target.reset();
    };

    return (
        <div className='contact-container container'>
            <div className="contact-form-container">
                <h2 className='contact-form-title'>Contact Us</h2>
                <form className='contact-form' onSubmit={sendEmail}>
                    <input
                        className='contact-form-input'
                        type="text"
                        id="name"
                        name="name"
                        placeholder='Full name'
                        required
                    />
                    <input
                        className='contact-form-input'
                        type="email"
                        id="email"
                        name="email"
                        placeholder='example@company.com'
                        required
                    />
                    <textarea
                        className='contact-form-input'
                        id="message"
                        name="message"
                        rows={5}
                        placeholder='Message*'
                        required
                    />
                    <button className='contact-button' type="submit">
                        Submit
                    </button>
                </form>
                {feedbackMessage && <p className={`feedback-message ${messageClass}`}>{feedbackMessage}</p>}
            </div>

            <div className="contact-info">
                <img src={contact_img}
                     className='contact-img'
                     alt='contact'
                />
            </div>
        </div>
    );
}

export default ContactForm;
